import React from "react";
import { useTranslation } from "react-i18next";
import LegalLayout from "@/pages/LegalLayout";

export default function CookiePolicy({ onOpenPrefs }) {
  const { t } = useTranslation();
  return (
    <LegalLayout titleKey="cookies_page.title" updatedKey="cookies_page.updated">
      <p>{t("cookies_page.intro")}</p>
      {[1,2,3,4,5,6,7].map((i) => (
        <React.Fragment key={i}>
          <h2>{t(`cookies_page.s${i}_t`)}</h2>
          <p>{t(`cookies_page.s${i}_p`)}</p>
        </React.Fragment>
      ))}
      <div className="mt-10">
        <button onClick={onOpenPrefs} className="zv-btn zv-btn-primary">
          {t("cookies_page.open_prefs")}
        </button>
      </div>
    </LegalLayout>
  );
}
